import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../components/molecules/TextField';
import Toggle from '../../components/atoms/Toggle';
import QuestionMark from '../../components/widgets/QuestionMark';
import css from './RangeInputs.css';

const toBound = value => {
    const num = Number(value);
    return value === '' || value === null || value === undefined || Number.isNaN(num) ? null : num;
};

const RangeInputs = ({ idPrefix, range, onChange }) => (
    <div className={css.row}>
        <TextField
            label="STATIC.PAGES.DASHBOARD.SHELF.AXIS.MIN"
            type="number"
            inputId={`${idPrefix}-axis-min`}
            placeholder="auto"
            value={range.min ?? ''}
            onChange={value => onChange({ ...range, min: toBound(value) })}
            containerClass={css.field}
        />
        <TextField
            label="STATIC.PAGES.DASHBOARD.SHELF.AXIS.MAX"
            type="number"
            inputId={`${idPrefix}-axis-max`}
            placeholder="auto"
            value={range.max ?? ''}
            onChange={value => onChange({ ...range, max: toBound(value) })}
            containerClass={css.field}
        />
        <div className={css.toggle}>
            <Toggle
                label="STATIC.PAGES.DASHBOARD.SHELF.AXIS.START_FROM_ZERO"
                checked={range.startFromZero !== false}
                onToggle={event => onChange({ ...range, startFromZero: event.target.checked })}
            />
            <QuestionMark interactive message="STATIC.PAGES.DASHBOARD.SHELF.AXIS.START_FROM_ZERO_HELP" />
        </div>
    </div>
);

RangeInputs.propTypes = {
    idPrefix: PropTypes.string.isRequired,
    range: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        startFromZero: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default RangeInputs;
